import { Observable } from 'rxjs';
import { map, startWith, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export interface LoadingState<T> {
  data: T;
  loading: boolean;
}

/**
 * Wraps an Observable to include loading state
 * @param source$ Source observable
 * @param initialData Initial data value (defaults to empty array for arrays, null for others)
 * @param onError Optional error handler, defaults to logging and returning initialData
 */
export function withLoadingState<T, E = Error>(
  source$: Observable<T>,
  initialData: T,
  onError?: (error: E) => T
): Observable<LoadingState<T>> {
  return source$.pipe(
    map((data): LoadingState<T> => ({ data, loading: false })),
    startWith({ data: initialData, loading: true }),
    catchError(error => {
      if (onError) {
        return of({ data: onError(error), loading: false });
      }
      console.error('Error in observable:', error?.error?.message || error);
      return of({ data: initialData, loading: false });
    })
  );
}
